import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SwalAlert from "../../../services/swalService/SwalService";
import { useAddEditEmailTemplateMutation, useLazyGetAllProjectTypeDropdownQuery } from "../../../app/services/FieldManagement/EmailTemplateManagement/EmailTemplateManagementApi";
import { useEffect } from "react";
import FormCreator from "../../../components/forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import DataLoader from "../../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { setAllDropDownFieldsBatch } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { AddEmailTempData } from "./dataFile/EmailManagementDataConfig";
import { getAuditContext } from "../../../lib/authenticationLibrary";

const AddNewEmailTemplate = () => {
    const addEmailTempRef = useRef();
    const navigate = useNavigate();

    const { success, error } = SwalAlert();
    const audit = getAuditContext();
    const [getAllProjectTypeDropdown, { isSuccess: isSuccessDropdown, isFetching: isFetchingDropdown, data: dropdownResponse }] = useLazyGetAllProjectTypeDropdownQuery()
    const [addEditEmailTemplate, { isSuccess: isSuccessAddEditEmail, isFetching: isFetchingAddEditEmail, data: addEditEmailResponse }] = useAddEditEmailTemplateMutation()

    useEffect(() => {
        if (!isFetchingAddEditEmail && isSuccessAddEditEmail && addEditEmailResponse) {
            if (addEditEmailResponse.hasError === false) {
                success("Email Added Successfully");
                handleBack();
            }
            else {
                error(addEditEmailResponse.errorMessage)
            }
        }
    }, [isFetchingAddEditEmail, isSuccessAddEditEmail, addEditEmailResponse]);


    useEffect(() => {
        if (!isFetchingDropdown && isSuccessDropdown && dropdownResponse) {
            const field = AddEmailTempData.section[0].rowGroup[0].fields.find(field => field.id === "projectType");
            field.fieldSetting.options = dropdownResponse.map(obj => ({ value: obj.id, label: obj.name }));
            setAllDropDownFieldsBatch(AddEmailTempData, dropdownResponse);
        }
    }, [isFetchingDropdown, isSuccessDropdown, dropdownResponse]);

    useEffect(() => {
        getAllProjectTypeDropdown();
    }, [])

    const handleaAdd = () => {
        const formData = addEmailTempRef.current.getFormData();
        const request = {
            EmailTemplateId: 0,
            EmailName: formData?.emailName,
            Subject: formData?.subject,
            WhereUsed: formData?.whereUsed,
            ProjectTypeId: formData?.projectType.value ? formData?.projectType.value : formData?.projectType,
            Description: formData?.description,
            CreatedBy: audit.adminUserId,
            CreatedAppId: audit.appId,
        }
        addEditEmailTemplate(request)
    }
    const handleBack = () => { navigate('/emailTemplateManagement') }
    return (
        <>
            {dropdownResponse ?
                <div className='d-flex flex-wrap'>
                    <div className='row email-template-form'>
                        <FormCreator
                            ref={addEmailTempRef}
                            config={AddEmailTempData}
                        >
                        </FormCreator>
                    </div>

                </div>
                :
                <DataLoader />
            }
            <div className='d-flex justify-content-between'>
                <div>
                    <Buttons
                        buttonText="Back"
                        buttonTypeClassName="theme-btn"
                        onClick={() => handleBack()}
                    />
                </div>
                <div>
                    <Buttons
                        buttonText="+ Add"
                        buttonTypeClassName="theme-btn"
                        onClick={() => handleaAdd()}
                    />
                </div>
            </div>
        </>
    )
}
export default AddNewEmailTemplate;